<style>
    span.k-widget.k-datepicker {
        width: 100%;
        height: calc(1.54em + 0.876rem + 2px);
    }
</style>
<template>
    <kendo-datepicker v-model="model"
                      v-mask="'##/##/#### ##:##'"
                      :format="'dd/MM/yyyy HH:mm'"
                      :required="required"
                      :disabled="disabled"
                      :placeholder="placeholder"
                      @input="inputDefault"></kendo-datepicker>
</template>

<script>
    export default {
        props: {
            value: null,
            input: { type: Function, default: null },
            required: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            placeholder: { default: '' }
        },
        methods: {
            inputDefault: function (val) {
                this.$set(val, this.model)
                if (this.input)
                    this.input(val)
            }
        },
        computed: {
            model: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', kendo.parseDate(value))
                }
            }
        }
    };
</script>